export interface InternetStatusResponseType {
  connectionId: number
  connectionType: string
  status: string
  ipAddress: string
  startTime: string
  stopTime: string
  callerId: string
  terminationCause: string
  uploadSpeed: number
  downloadSpeed: number
  usage: {
    up: number
    down: number
  }
}

export interface InternetUsageResponse {
  dateFrom: string
  dateTo: string
  period: string
  usage: InternetUsageResponseData[] | undefined
}
export interface InternetUsageResponseData {
  date: string
  up: number
  down: number
}

export interface InternetUsageRequestBody {
  dateFrom: string
  dateTo: string
  period: string
}

export const isInternetUsageResponse = (object: any): object is InternetUsageResponse => {
  if (object === undefined) {
    return false
  }
  if ('usage' in object && Array.isArray(object.usage)) {
    return 'up' in object.usage[0]
  }
  return false
}

export const isInternetStatusResponseType = (response: any): response is Array<InternetStatusResponseType> => {
  if (response === undefined) {
    return false
  }
  if (Array.isArray(response)) {
    return 'terminationCause' in response[0]
  }
  return 'terminationCause' in response
}
